module.exports = __webpack_public_path__ + "img/logo-01.9d1eed2e.png";